/**
 * 國際化配置
 */

import { createI18n } from 'vue-i18n'
import zhTW from './zh-TW'

// 語言配置
const messages = {
  'zh-TW': zhTW
}

// 創建 i18n 實例
const i18n = createI18n({
  legacy: false, // 使用 Composition API
  locale: 'zh-TW', // 默認語言
  fallbackLocale: 'zh-TW', // 回退語言
  messages,
  globalInjection: true // 全局注入
})

export default i18n